'use client'

import { ModelsNewsMediaBlock } from '@/api/generated-api'
import Image from '@/ui/MediaImage'

import NewsArticleVideoPlayer from './NewsArticleVideoPlayer'
import S from './NewsMediaBlock.module.scss'
import NewsMediaCarousel from './NewsMediaCarousel'

type NewsMediaBlockProps = {
  block?: ModelsNewsMediaBlock
  title: string
}

const NewsMediaBlock = ({ block, title }: NewsMediaBlockProps) => {
  if (!block?.kind || !block.items?.length) {
    return null
  }

  const item = block.items[0]

  if (block.kind === 'video' && item.url) {
    return (
      <NewsArticleVideoPlayer
        videoUrl={item.url}
        posterUrl={item.cover_url}
        title={title}
      />
    )
  }

  if (block.kind === 'carousel') {
    return <NewsMediaCarousel items={block.items} title={title} />
  }

  if (block.kind === 'image' && item.url) {
    return (
      <div className={S.image}>
        <Image
          src={item.url}
          alt={title}
          fill
          className={S.imageContent}
          sizes="(max-width: 768px) 100vw, 1000px"
        />
      </div>
    )
  }

  return null
}

export default NewsMediaBlock
